var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form pwds-form" },
    [
      !!_vm.errorMessage
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c("i", { staticClass: "fa fa-exclamation-triangle mr-2" }),
            _vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("PassordFields", { on: { passwordValidity: _vm.onPasswordValidity } }),
      _vm._v(" "),
      _c(
        "Btn",
        {
          staticClass: "primary reverse block mt-4",
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.saveForm($event)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("global.save")) + "\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }